// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__j4VKC","requiredAsterisk":"Info_requiredAsterisk__N4fu4"};